var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current)?_c('media-player',{attrs:{"media":_vm.current},on:{"show":function($event){return _vm.onShow()},"hide":function($event){return _vm.onHide()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }